import {SimpleForm, useTranslate, Toolbar, SaveButton, useRefresh, Identifier} from "react-admin";
import {Typography} from "@mui/material";
import {CreateInDialogButton, EditInDialogButton} from "@react-admin/ra-form-layout";
import * as React from "react";
import {Transition} from "../OrderReturnShow";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import {returnStates} from "../returnStates";

const CreateShippingCostDialog = (props: { returnId: Identifier }) => {
    const t = useTranslate();
    const refresh = useRefresh();

    return (
        <CreateInDialogButton
            title={`resources.order.return.newShippingCostConfirmationTitle`}
            mutationOptions={{
                onSuccess: () => {
                    refresh();
                }
            }}
            ButtonProps={
                {
                    label: `resources.order.return.newShippingCostConfirmationButtonLabel`,
                    startIcon: false,
                    color: 'inherit',
                }
            }
            resource={`order-returns/${props.returnId}/shipping-costs`}
        >
            <SimpleForm
                toolbar={
                    <Toolbar>
                        <SaveButton label={`ra.action.confirm`} icon={<ThumbUpIcon/>} alwaysEnable/>
                    </Toolbar>
                }
            >
                <Typography variant="body1" gutterBottom>
                    {t(`resources.order.return.newShippingCostConfirmationMessage`)}
                </Typography>
            </SimpleForm>
        </CreateInDialogButton>
    );
};

export default CreateShippingCostDialog;
